import { useState, MouseEvent, useEffect } from 'react';
import GridComponent from '../../../component/grid/GridComponent.component';
import { useSnackbar } from '../../../context/Snackbar';
import xlsx from 'json-as-xlsx';

import Table from '../../../component/table/Table.component';
import { Pagination } from '../../../component/table/interfaces/Pagination';
import { INITIAL_PAGINATION } from '../../../component/table/component/pagination/utils/Pagination';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { compare } from './utils/order/compare';
import { get, limparFila, reprocessar } from '../Security.service';
import { AxiosError } from 'axios';
import { FormatDateHours } from '../../../utils/format/FormatDate';
import ButtonComponent from '../../../component/buttton/Button.component';

interface IExcel {
  sheet: string;
  columns: Array<{ label: string; value: any }>;
  content: Array<any>;
}

interface IProcess {
  process_id: number;
  data: any;
  hash: string;
  log?: string;
  state: string;
  origin: string;
  origin_id: string;
  created_at: string;

  id?: number;
  local: string;
  user_ad: string;
  user_name: string;
  user_email: string;
  user_phone: string;
  action: string;
  action_id: string;
}

const ProcessQueue = () => {
  const { setSnackbar } = useSnackbar();
  // const [load, setLoad] = useState(false);
  const [process, setProcess] = useState<IProcess[]>([]);
  const [processAux, setProcessAux] = useState<IProcess[]>([]);
  const [request, setRequest] = useState<boolean>(true);
  const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);

  // SEND REQUEST FOR XSLX TEST AND SEND RESPONSE WITH FILE
  const downloadXLSX = async (origin: 'US' | 'GE' | 'RE' | 'BA', filename: string) => {
    try {
      console.log(process);
      const dtProc = process.filter((d) => d.origin_id === origin);
      let content: any[] = [];

      if (origin === 'GE') {
        content = dtProc.map((d) => {
          const dt = JSON.parse(d.data);
          return {
            'ID*': dt[0],
            Bandeira: dt[1],
            'Gerente AD*': dt[2],
            'Gerente Nome': dt[3],
            'Telefone Gerente': dt[4],
            'Gerente Email': dt[5],
            Log: d.log,
          };
        });
      } else if (origin === 'RE') {
        content = dtProc.map((d) => {
          const dt = JSON.parse(d.data);
          return {
            'ID*': dt[0],
            Bandeira: dt[1],
            Regional: dt[2],
            'Gerente Regional AD*': dt[3],
            'Gerente Regional Nome': dt[4],
            'Telefone Gerente Regional': dt[5],
            'Gerente Email': dt[6],
            Log: d.log,
          };
        });
      } else if (origin === 'BA') {
        content = dtProc.map((d) => {
          const dt = JSON.parse(d.data);
          return {
            'ID*': dt[0],
            Nome: dt[1],
            'Diretor da Bandeira AD*': dt[2],
            'Diretor da Bandeira Nome': dt[3],
            'Telefone Diretor da Bandeira': dt[4],
            'Email Diretor da Bandeira': dt[5],
            Log: d.log,
          };
        });
      } else {
        content = dtProc.map((d) => {
          const dt = JSON.parse(d.data);
          return {
            ID: dt[0],
            'Loja*': dt[1],
            'Usuário AD*': dt[2],
            'Usuário Nome': dt[3],
            Email: dt[4],
            Telefone: dt[5],
            'Ação* (I, A ou E)': dt[6],
            Log: d.log,
          };
        });
      }
      let headers: string[] = Object.keys(content[0]);

      let data: IExcel[] = [
        {
          sheet: filename.toUpperCase(),
          columns: [],
          content: content,
        },
      ];

      headers.forEach((r) => {
        data[0].columns.push({
          label: r,
          value: r,
        });
      });

      let settings = {
        fileName: `base-${filename}`,
      };
      xlsx(data, settings);
    } catch (err) {
      setSnackbar({
        type: 'error',
        msg: 'Erro ao coletar os dados!',
        subMsg: 'Verificar o log para mais informação',
      });
      console.log(`Error when format data for export: ${filename}`, err);
    }
  };

  const getData = async () => {
    get()
      .then((res) => {
        if (res.data) {
          const response: IProcess[] = filter(res.data);
          setProcess([...response]);
          setProcessAux([...response]);
        }
      })
      .catch((error: AxiosError) => {
        console.log(error.response?.data);
        console.log(error);
        setSnackbar({ msg: 'Erro ao consultar a fila de processamento!', type: 'error' });
      })
      .finally(() => {
        setRequest(false);
      });
  };

  useEffect(() => {
    getData();
    const interval = setInterval(() => {
      getData();
    }, 10000);
    return () => {
      return clearInterval(interval);
    };
  }, []);

  const filter = (data: any[]) => {
    let dataAux: any[] = [];
    data.forEach((el: any) => {
      const payload = JSON.parse(el.data);
      let pData: any = {
        local: '',
        user_ad: '',
        user_name: '',
        user_email: '',
        user_phone: '',
        action: '',
        action_id: '',
      };

      if (el.origin === 'US') {
        pData.id = payload[0];
        pData.local = payload[1];
        pData.user_ad = payload[2];
        pData.user_name = payload[3];
        pData.user_email = payload[4];
        pData.user_phone = payload[5];
        pData.action =
          payload[6] === 'I' ? 'Inclusão' : payload[6] === 'A' ? 'Alteração' : 'Exclusão';
        pData.action_id = payload[6];
      } else if (el.origin === 'GE') {
        pData.id = payload[0];
        pData.local = payload[0];
        pData.user_ad = payload[3];
        pData.user_name = payload[4];
        pData.user_email = payload[5];
        pData.user_phone = payload[6];
        pData.action = 'Alteração';
      } else if (el.origin === 'RE') {
        pData.id = payload[0];
        pData.local = `${payload[1]} | ${payload[2]}`;
        pData.user_ad = payload[2];
        pData.user_name = payload[3];
        pData.user_email = payload[4];
        pData.user_phone = payload[5];
        pData.action = 'Alteração';
      } else if (el.origin === 'BA') {
        pData.id = payload[0];
        pData.local = payload[1];
        pData.user_ad = payload[2];
        pData.user_name = payload[3];
        pData.user_email = payload[5];
        pData.user_phone = payload[4];
        pData.action = 'Alteração';
      }

      const dt: IProcess = {
        process_id: el.id,
        data: el.data,
        hash: el.hash,
        log: el.log,
        state: el.state === 1 ? 'Em fila' : el.state === 2 ? 'Processando' : 'Com erro',
        origin:
          el.origin === 'US'
            ? 'Loja Principal'
            : el.origin === 'GE'
            ? 'Gerente Loja'
            : el.origin === 'RE'
            ? 'Gerente Regional'
            : 'Diretor Bandeira',
        origin_id: el.origin,
        created_at: FormatDateHours(el.created_at),
        ...pData,
      };
      dataAux.push(dt);
    });
    return dataAux;
  };

  const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
    const isAsc = pagination.sort === property && pagination.order === 1;
    setProcessAux(processAux.sort((a: any, b: any) => compare(a, b, property, isAsc ? -1 : 1)));
    setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
  };

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPagination({ ...pagination, page: newPage + 1 });
  };

  const pageSelect = (processAux: IProcess[]) => {
    if (pagination.page) {
      return processAux.slice((pagination.page - 1) * 30, pagination.page * 30);
    }
    return processAux;
  };

  return (
    <>
      <GridComponent justify='space-between' alignItems='center'>
        <div style={{ display: 'flex' }}>
          <ButtonComponent
            onClick={() => downloadXLSX('US', 'usuario_loja_principal_erros')}
            title='Excel | Erros Loja Principal'
            size='medium'
            margin='16px 0px 0px 0px'
          />
          <ButtonComponent
            onClick={() => downloadXLSX('US', 'usuario_gerente_loja_erros')}
            title='Excel | Erros Gerente Loja'
            size='medium'
            margin='16px 0px 0px 10px'
          />
          <ButtonComponent
            onClick={() => downloadXLSX('US', 'usuario_gerente_regional_erros')}
            title='Excel | Erros Gerente Regional'
            size='medium'
            margin='16px 0px 0px 10px'
          />{' '}
          <ButtonComponent
            onClick={() => downloadXLSX('US', 'usuario_diretor_bandeira_erros')}
            title='Excel | Erros Diretor Bandeira'
            size='medium'
            margin='16px 0px 0px 10px'
          />
        </div>
        <div style={{ display: 'flex' }}>
          <ButtonComponent
            onClick={() => {
              reprocessar();
              setSnackbar({
                type: 'success',
                msg: 'Sucesso',
                subMsg: 'Processamento iniciado',
              });
            }}
            title='Processar'
            size='medium'
            margin='16px 0px 0px 10px'
          />
          <ButtonComponent
            onClick={() => {
              limparFila();
              setSnackbar({
                type: 'success',
                msg: 'Sucesso',
                subMsg: 'Fila removida!',
              });
              setProcess([]);
              setProcessAux([]);
            }}
            title='Limpar'
            size='medium'
            margin='16px 0px 0px 10px'
          />
        </div>
      </GridComponent>

      <br />
      <br />
      <Table
        request={request}
        data={pageSelect(processAux)}
        size={processAux.length}
        headCells={HEAD_CELL}
        page={pagination.page}
        onChangePage={handleChangePage}
        noActionView
        noActionDelete
        noActionEdit
        order={pagination.order === 1 ? 'asc' : 'desc'}
        orderBy={pagination.sort}
        onRequestSort={handleRequestSort}
      />
    </>
  );
};

export default ProcessQueue;
